import React, { useRef } from "react";
import TradeCallsForm from "../common/TradeCallsForm";
import TradeCallsTable from "../common/TradeCallsTable";
import MuiModal from "../../../muiComps/MuiModal";

// This component should contain the Form, the multiselect plans list and the table, same as 'Advisor Home'
const SelectedTradeTab = ({
  selectedTradeType,
  isEditing,
  setIsEditing,
  tradesFormInput,
  setTradesFormInput,
  clearTradesFormInput,
  activeAdvisoryObj,
  allTradesList,
  handleEditBtn,
  handleCancelBtn,
  handleExitBtn,
  isFormModalOpen,
  setIsFormModalOpen,
  handleCloseFormModal,
  refreshTrades
}) => {
  // const [isEditing, setIsEditing] = useState(false);
  const exitPriceRef = useRef(null);

  return (
    <div>
      {/* <h2>{selectedTradeType}</h2> */}

      {/* Trade Form Modal */}
      <MuiModal open={isFormModalOpen} setOpen={setIsFormModalOpen} maxWidth={isEditing ? "580px" : "1200px"}>
        <TradeCallsForm
          isEditing={isEditing}
          setIsEditing={setIsEditing}
          tradesFormInput={tradesFormInput}
          setTradesFormInput={setTradesFormInput}
          clearTradesFormInput={clearTradesFormInput}
          activeAdvisoryObj={activeAdvisoryObj}
          exitPriceRef={exitPriceRef}
          selectedTradeType={selectedTradeType}
          handleCloseFormModal={handleCloseFormModal}
          refreshTrades={refreshTrades}
        />
      </MuiModal>

      {/* advisory details table */}
      <TradeCallsTable
        allTradesList={allTradesList}
        handleEditBtn={handleEditBtn}
        handleCancelBtn={handleCancelBtn}
        handleExitBtn={handleExitBtn}
        selectedTradeType={selectedTradeType}
        refreshTrades={refreshTrades}
        
      />
    </div>
  );
};

export default SelectedTradeTab;
